import { createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { ProjectsPage } from "@/features/projects";

export const Route = createFileRoute("/projects/")({
  component: () => (
    <PermissionGuard module="projects">
      <ProjectsPage />
    </PermissionGuard>
  ),
});
